import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { AlertTriangle, Info } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Button } from "./button";

export default function ConfirmModal({ isOpen, title, message, confirmText, cancelText, type, onConfirm, onCancel }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <Dialog static open={isOpen} onClose={onCancel} className="relative z-[100]">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm"
            aria-hidden="true"
          />
          
          <div className="fixed inset-0 flex items-center justify-center p-4">
            <DialogPanel 
              as={motion.div}
              initial={{ opacity: 0, scale: 0.95, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 10 }}
              className="relative bg-surface rounded-xl shadow-2xl p-6 w-full max-w-md border border-[var(--hp-color-border-muted)]"
            >
              <div className="flex items-start gap-4">
                <div className={`shrink-0 p-3 rounded-full ${type === 'danger' ? 'bg-danger-100 text-danger-600' : 'bg-info-100 text-secondary'}`}>
                  {type === 'danger' ? <AlertTriangle className="w-6 h-6" /> : <Info className="w-6 h-6" />}
                </div>
                <div className="flex-1 mt-1">
                  <DialogTitle className="text-lg font-semibold text-primary">{title}</DialogTitle>
                  <p className="mt-2 text-sm text-subtle">{message}</p>
                </div>
              </div>
              
              <div className="mt-6 flex justify-end gap-3">
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={onCancel}
                >
                  {cancelText}
                </Button>
                <Button
                  variant={type === 'danger' ? "destructive" : "primary"}
                  size="sm"
                  onClick={onConfirm}
                >
                  {confirmText}
                </Button>
              </div>
            </DialogPanel>
          </div>
        </Dialog>
      )}
    </AnimatePresence>
  );
}
